import styled, { css, RuleSet } from 'styled-components';

export const OuterContainer = styled.div<{
  $showMobileNavBar: boolean;
}>(({ $showMobileNavBar, theme }) => {
  const gridSetup = $showMobileNavBar
    ? css`
        padding-bottom: ${theme.sz.s12};
        grid-template-columns: 1fr;
        grid-template-rows: max-content 1fr max-content;
        grid-template-areas:
          'header'
          '...'
          'navbar';
      `
    : css`
        grid-template-columns: max-content 1fr;
        grid-template-rows: max-content 1fr;
        grid-template-areas:
          'sidebar header'
          'sidebar ...';
      `;

  return css`
    display: grid;
    ${gridSetup};
    min-height: 100dvh;
  `;
});

export const HeaderContainer = styled.div(
  ({ theme }) => css`
    position: sticky;
    top: 0;
    grid-area: header;
    z-index: ${theme.zi.header};
  `,
);

export const PageContent = styled.div(
  ({ theme }) => css`
    width: 100%;
    height: 100%;
    padding: ${theme.sz.s2} ${theme.sz.s8} ${theme.sz.s12} ${theme.sz.s8};

    @media (max-width: ${theme.sz.md}) {
      padding: ${theme.sz.s2} ${theme.sz.s4} ${theme.sz.s7} ${theme.sz.s4};
    }
  `,
);

export const ContentArea = styled.div<{ $background?: RuleSet<object> }>(
  ({ $background }) => css`
    overflow: auto;
    width: 100%;
    height: 100%;

    ${$background}
  `,
);

export const MobileNavBar = styled.div(
  ({ theme }) => css`
    width: 100%;
    height: ${theme.sz.s16};
    position: fixed;
    bottom: 0;
    grid-area: navbar;
    z-index: ${theme.zi.z5};
  `,
);

export const Sidebar = styled.div(
  ({ theme }) => css`
    height: 100dvh;
    position: sticky;
    top: 0;
    grid-area: sidebar;
    z-index: ${theme.zi.z1};
  `,
);
